import React from 'react';
import ReactDOM           from 'react-dom';
import {
  HashRouter as Router, Redirect,
  Route
}                         from 'react-router-dom'
import { ConfigProvider } from 'antd';
import zhCN               from 'antd/lib/locale/zh_CN';
import 'antd/dist/antd.css';
import './index.css';
import ChannelPurchase    from './pages/ChannelPurchase';
import reportWebVitals    from './reportWebVitals';
import AuthWrapper        from './components/AuthWrapper'

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Router>
      <Route path="/" exact>
        <Redirect to={'/default'}/>
      </Route>
      <Route path="/:inviteCode" component={AuthWrapper(ChannelPurchase)}>
      </Route>
    </Router>
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
